import {HttpClient} from "../../service/httpClient/HttpClient";

export class ProductService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getProductList(page, size, title, slug) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `products`,
                {
                    page,
                    size,
                    title,
                    slug
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewProduct(title, slug) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `products`,
                {
                    title,
                    slug
                }
            ).then(resolve).catch(reject)
        })
    }

    getProductDetails(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `products/${id}/information`
            ).then(resolve).catch(reject)
        })
    }

    updateProductDetails(id, title, slug, description) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `products/${id}/information`,
                {
                    title,
                    slug,
                    description,
                }
            ).then(resolve).catch(reject)
        })
    }

    updateProductPublishState(id,enabled){
        return new Promise((resolve, reject)=>{
            this.httpClient.patch(
                `products/${id}/enabled`,
                {},
                {
                    enabled
                }
            ).then(resolve).catch(reject)
        })
    }
    getProductEnabled(id){
        return new Promise((resolve, reject)=>{
            this.httpClient.get(
                `products/${id}/enabled`,
            ).then(resolve).then(reject)
        })
    }
}